const initialState ={
  showerror:false,
  isPending:false,
  isPendingCompliance:false,
  isPendingCsat:false,
  isPendingTransact:false,
}
export default (state = initialState, action) => {
  switch (action.type) {
    case "DOCUMENT_NAME":
      return Object.assign({}, state, {
      result: action.payload
    })
    case "FILE_MODAL_CLOSE":
      return Object.assign({}, state, {
       showerror: action.showerror
    })
    case "FILE_ERROR":
      return Object.assign({}, state, {
        showerror: action.showerror,
        errmessage: action.errmessage,
        isPending: action.isPending
    })
    case "FILE_MODAL_PENDING":
      return Object.assign({}, state, {
        isPending: action.isPending
    })
    case "FILE_MODAL_PENDING_COMPLIANCE":
      return Object.assign({}, state, {
        isPendingCompliance: action.isPending
    })
    case "FILE_MODAL_PENDING_TRANSACT":
      return Object.assign({}, state, {
        isPendingTransact: action.isPending
    })
    case "FILE_MODAL_PENDING_CSAT":
      return Object.assign({}, state, {
        isPendingCsat: action.isPending
    })
    case "FILE_ERROR_COMPLIANCE":
      return Object.assign({}, state, {
        showerror: action.showerror,
        errmessage: action.errmessage,
        isPendingCompliance: action.isPending
    })
    case "FILE_ERROR_TRANSACT":
      return Object.assign({}, state, {
        showerror: action.showerror,
        errmessage: action.errmessage,
        isPendingTransact: action.isPending
    })
    case "FILE_ERROR_CSAT":
      return Object.assign({}, state, {
        showerror: action.showerror,
        errmessage: action.errmessage,
        isPendingCsat: action.isPending
    })
    case "FILE_MODAL_PENDING_CRM":
      return Object.assign({}, state, {
        isPendingCsat: action.isPending
    })
    case "FILE_MODAL_PENDING_CLI":
      return Object.assign({}, state, {
        isPendingCsat: action.isPending
    })
    case "FILE_ERROR_CLI":
      return Object.assign({}, state, {
        showerror: action.showerror,
        errmessage: action.errmessage,
        isPendingCsat: action.isPending
    })
    case "FILE_ERROR_CRM":
      return Object.assign({}, state, {
        showerror: action.showerror,
        errmessage: action.errmessage,
        isPendingCsat: action.isPending
    })
    case "SCREEN_MESSAGE":
      return Object.assign({}, state, {
        screenMessage: action.screenMessage,
        isPending: action.isPending
    })
    case "SCREEN_MESSAGE_RESET":
      return Object.assign({}, state, {
        screenMessage: action.screenMessage
    })
  default:
    return state
  }
}